/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actiontypes from './actiontypes';

const initialState = {};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actiontypes.AR_MFG_FLD_DATA:
      return { ...state, ar_manu_fld: action.payload };
    case actiontypes.AR_MFG_TBL_DATA:
      return { ...state, ar_manu_tbl: action.payload };
    case actiontypes.AR_MFG_UNALLOCATED_VAL:
      return { ...state, unallocated: action.payload };
    case actiontypes.AR_MFG_NDC_DETAIL:
      return { ...state, ndc_data: action.payload };
    case actiontypes.AR_MFG_FIRST_LOAD:
      return { ...state, arMfgFirstLoad: action.payload };
    case actiontypes.AR_MANUFACTURER_CLEAR_REDUX:
      return action.payload ? action.payload : {};
    default:
      return state;
  }
};

export default reducer;
